import script from "./FlyingTiger-ProductMetrics.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyingTiger-ProductMetrics.vue?vue&type=script&setup=true&lang=js"

import "./FlyingTiger-ProductMetrics.vue?vue&type=style&index=0&id=bd25f6b0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd25f6b0"]])

export default __exports__